<table class="lum-table lum-table--classic striped">
  <tr>
    <th class="w-64">Supplier Name</th>
    <th>SKU</th>
    <th></th>
  </tr>
  <tbody>
    <ng-container *ngFor="let supplierSku of supplierSkus; trackBy: trackById">
      <tr>
        <td class="w-64">{{ supplierSku?.supplier.factoryName }}</td>
        <td>{{ supplierSku?.sku }}</td>
        <td>
          <div class="flex justify-content-end">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        </td>
      </tr>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onEditSupplierSku(supplierSku)">
          Edit
        </button>
        <button (click)="onDeleteSupplierSku(supplierSku)" mat-menu-item>
          Delete
        </button>
      </mat-menu>
    </ng-container>
  </tbody>
</table>
